import "../styles/hero.css";
import Great from "../assets/greate_gardens.webp";
import Brief from "../assets/brief.webp";
import About from "../assets/about.webp";
import Hero from "../assets/hero.webp";
import Home_gallery1 from "../assets/home_gallery1.jpg";
import Home_gallery2 from "../assets/home_gallery2.jpg";
import Home_gallery3 from "../assets/home_gallery3.jpg";
import Home_gallery4 from "../assets/home_gallery4.jpg";
import Home_gallery5 from "../assets/home_gallery5.JPG";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-regular-svg-icons";
import { Fragment, useEffect, useMemo, useState } from "react";
import { getData } from "../api";
import { Link } from "react-router-dom";

function Home({
  locationTitle = "Location",
  locationLines = ["Brief, Kalawila", "Village, Beruwala."],
  hoursTitle = "Opening Hours",
  hoursLines = ["8:00 am - 4:30 pm", "Open everyday"],
  priceTitle = "Entrance Fee",
  priceLines = ["US$ 15 per person"],
}) {
  const formatLKR = (n) =>
    new Intl.NumberFormat("en-LK", {
      style: "currency",
      currency: "LKR",
      maximumFractionDigits: 2,
    }).format(n);
  const formatUSD = (n) =>
    new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 2,
    }).format(n);

  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        // call your API (no leading slash if your getData already adds /api/v1/)
        const res = await getData(
          "packages?page=1&limit=10&sort=code"
        );
        const list = Array.isArray(res?.items)
          ? res.items
          : Array.isArray(res?.data)
          ? res.data
          : Array.isArray(res)
          ? res
          : [];
        if (alive) setItems(list);
      } catch (e) {
        console.error(e);
        if (alive) setErr("Failed to load packages.");
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => {
      alive = false;
    };
  }, []);

  const plans = useMemo(() => {
    const entranceUsd =
      items.find((p) => p.kind === "GARDEN_VISIT")?.priceAdultUsd ?? 0;
    const mapped = items.map((p, idx) => {
      const isDark = idx % 2 === 1;
      const priceLines = [];

      // Only USD prices are shown (no LKR)
      if (p.kind === "GARDEN_VISIT") {
        priceLines.push(`Price: US ${formatUSD(p.priceAdultUsd)}`);
        priceLines.push({ text: "(US$=LKR -CBSL Middle rate of the day)" });
      } else if (p.priceAdultUsd > 0) {
        // "Price includes the entrance ticket plus USD 17.50 per person"
        const extra = Number(
          /USD\s*([\d.]+)\s*per person/i.exec(p.note || "")?.[1]
        );
        if (extra > 0 && entranceUsd > 0) {
          priceLines.push(
            `Price: US ${formatUSD(entranceUsd)} + US ${formatUSD(
              extra
            )} = US ${formatUSD(entranceUsd + extra)}`
          );
          priceLines.push({ text: "(US$=LKR -CBSL Middle rate of the day)" });
        } else {
          priceLines.push(`Price: US ${formatUSD(p.priceAdultUsd)}`);
        }
      }

      if (p.kind === "EVENTS" && p.note) {
        // Split the note into: Non-Commercial, Commercial, Local and Foreign events
        p.note
          .split(/(?=Non-Commercial Shoots:|(?<!Non-)Commercial Shoots:|Events:)/)
          .map((part) => part.trim())
          .filter(Boolean)
          .forEach((part) => {
            if (part.startsWith("Events:")) {
              part
                .replace("Events:", "")
                .split(/\.\s+(?=Foreign)/)
                .forEach((ev) =>
                  priceLines.push(ev.replace(/\s+-\s+/, ": ").trim())
                );
            } else {
              priceLines.push(part);
            }
          });
      } else if (p.note) {
        priceLines.push(p.note);
      }

      return {
        id: String(idx + 1).padStart(2, "0"),
        title: p.name,
        description: p.description || p.code.replaceAll("_", " "),
        priceLines,
        bg: isDark ? "dark" : "light",
        code: p.code,
      };
    });

    return mapped;
  }, [items]);

  if (loading) return <div className="container py-5">Loading packages…</div>;
  if (err) return <div className="container py-5 text-danger">{err}</div>;

  return (
    <>
      <section className="hero">
        <div className="container">
          <div className="row w-100 mt-5">
            <div className="col-10"></div>
            <div className="col-5 mx-auto mx-md-0 col-md-1 p-md-1">
              <img className="w-100" src={Great} alt="greate_gardens" />
            </div>
          </div>
          <div className="row w-100 mx-0">
            <div className="col-12 col-md-5 p-0">
              <img className="w-100" src={Brief} alt="brief" />
              <p className="plain_text">
                Brief Garden still carries the unmistakable mark of his bold and
                artistic spirit—a timeless space where design, nature, and
                personality come together.
              </p>
            </div>
            <div className="col-7"></div>
          </div>
          <div className="row">
            <div className="col-md-5"></div>
            <div className="col-12 col-md-7">
              <div className="glass-card1">
                <div className="glass-table">
                  <div className="glass-fee">
                    <h3 className="glass-heading">{priceTitle}</h3>
                    <p className="glass-fee-price">{priceLines[0]}</p>
                  </div>
                  <h3 className="glass-heading glass-col-location">
                    {locationTitle}
                  </h3>
                  <h3 className="glass-heading glass-col-hours">{hoursTitle}</h3>
                  {locationLines.map((line, i) => (
                    <Fragment key={i}>
                      <p className="glass-text glass-col-location">{line}</p>
                      <p className="glass-text glass-col-hours">
                        {hoursLines[i]}
                      </p>
                    </Fragment>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container py-5">
          <div className="row m-0 p-0 mt-5">
            <div className="col-12 col-md-4">
              <p className=" section-tag">
                [<span>About</span>]
              </p>
            </div>
            <div className="col-12 col-md-8 ps-md-5 pe-md-0">
              <p className="section-header">
                Where Art, Nature, and Story Come to Life
              </p>
            </div>
            <div className="col-12 col-md-4 mt-md-5">
              <img src={About} className="section-image w-100" alt="brief" />
            </div>
            <div className="col-md-8  mt-5 section-content ps-md-5">
              <div>
                <p className="plain_text">
                  Brief Garden, eight kilometres inland from Bentota or
                  Beruwela, was the sylvan refuge of Bevis Bawa (1909-92), the
                  elder brother of Geoffrey Bawa, Sri Lanka's most famous
                  architect. The gardens got their name, because Bevis Bawa's
                  father purchased this land after a successful legal brief. The
                  estate had formerly been a rubber plantation. It was
                  transformed into a tropical landscape garden inspired by local
                  traditions as well as Italian an English landscape gardens.
                </p>
                <p className="plain_text">
                  The garden architecture, covering about two hectares, is a mix
                  of Italian villa garden, English landscape garde, and tropical
                  forest with a jungle-book atmosphere. However, most of the
                  vegetation is the result of gardening activities, many
                  tropical decorational plants are grown in Brief Garden.
                </p>
                <p className="plain_text">
                  The villa is situated at the highest point of the estate and
                  at the upper end of two diverse visual axis, one is a water
                  garden arranged symmetrically along a long cascade, the other
                  one consisting of flat greens on different levels. Their joint
                  close to the villa is a small Chinese water garden.
                </p>
                <p className="plain_text">
                  Bawa's house, painted a soft apricot with terra cotta tiles,
                  is designed to allows smooth transition of architecture and
                  nature and is a blend of salons, verandahs and patios. The
                  villa contains a private library with a collection of Asian
                  statues as well as paintings, photographies and ornaments,
                  some are quite imaginative, for example a double-grown coconut
                  in the shape of a vagina.
                </p>
              </div>
              <div className="d-flex justify-content-end align-items-end">
                <div style={{ height: "fit-content" }}>
                 <Link to="/about" >
                  <button className="btn-bawa primary-dark-btn">
                    see more
                  </button>
                 </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="dark-bg">
        <div className="container py-5">
          <div className="row mt-5">
            <div className="col-12 col-md-8 ps-1">
              <p className="section-header light-text">Explore Our Packages</p>
            </div>
            <div className="col-12 col-md-4">
              <p className="text-end section-tag">
                [<span>Packages</span>]
              </p>
            </div>
            <div className="col-12  mt-md-5  ">
              <div className="visit-grid row p-3">
                {plans.map((plan, index) => (
                  <div
                    className="col-12 col-md-6 col-lg-4 p-3"
                    key={plan.id /* key on outermost */}
                  >
                    <div className="glass-card package-card">
                      <div className="plan-id">{plan.id}</div>
                      <h3 className="text-uppercase">{plan.title}</h3>
                      <p className="description">{plan.description}</p>

                      <div className="price">
                        {plan.priceLines.map((line, i) => (
                          <p key={i} className={line.text ? "price-sub" : ""}>
                            {line.text ? (
                              line.text
                            ) : (
                              <>
                                <FontAwesomeIcon
                                  icon={faCircleCheck}
                                  className="check-icon"
                                />{" "}
                                {line}
                              </>
                            )}
                          </p>
                        ))}
                      </div>

                      <Link
                        to={`/booking?package=${encodeURIComponent(plan.code)}`}
                        className=" card-button p-0 mt-5"
                      >
                        <button className="btn-bawa outline-btn">
                          Book Now
                        </button>
                      </Link>
                    </div>
                  </div>
                ))}
              </div>
              {/* <div className="row p-0 m-0 ">
                <div className=" col-md-4 p-2">
                  <div class="glass-card">
                    <h1 class="card-number">01</h1>
                    <h2 class="card-title">VISIT ONLY</h2>
                    <p class="card-desc">
                      Wander through the iconic Brief Garden and explore its
                      lush landscapes, sculptures, and timeless design at your
                      own pace.
                    </p>
                    <ul class="card-details">
                      <li className="d-flex">
                        <div>
                          <FontAwesomeIcon
                            icon={faCircleCheck}
                            className="card-icon"
                          />
                        </div>

                        <div>
                          Price: US$ 10
                          <br />
                          <small>
                            (Equivalent To CBSL Middle Rate Of The Day)
                          </small>
                        </div>
                      </li>
                      <li className="d-flex">
                        <div>
                          <FontAwesomeIcon
                            icon={faCircleCheck}
                            className="card-icon"
                          />
                        </div>
                        <div>Tickets available at the gate.</div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className=" col-md-4 p-2">
                  <div class="glass-card">
                    <h1 class="card-number">02</h1>
                    <h2 class="card-title">VISIT ONLY</h2>
                    <p class="card-desc">
                      Wander through the iconic Brief Garden and explore its
                      lush landscapes, sculptures, and timeless design at your
                      own pace.
                    </p>
                    <ul class="card-details">
                      <div className="mb-3">
                        <strong>Price:</strong>
                      </div>
                      <li className="d-flex">
                        <div>
                          <FontAwesomeIcon
                            icon={faCircleCheck}
                            className="card-icon"
                          />
                        </div>
                        <div>
                          US$ 10
                          <br />
                          <small>
                            (Equivalent To CBSL Middle Rate Of The Day)
                          </small>
                        </div>
                      </li>
                      <li className="d-flex">
                        <div>
                          <FontAwesomeIcon
                            icon={faCircleCheck}
                            className="card-icon"
                          />
                        </div>
                        <div> Tickets available at the gate.</div>
                      </li>
                    </ul>
                    <div className="card-button mt-5 ">
                      <button className="btn-bawa outline-btn">see more</button>
                    </div>
                  </div>
                </div>
                <div className=" col-md-4 p-2">
                  <div class="glass-card">
                    <h1 class="card-number">03</h1>
                    <h2 class="card-title">VISIT ONLY</h2>
                    <p class="card-desc">
                      Wander through the iconic Brief Garden and explore its
                      lush landscapes, sculptures, and timeless design at your
                      own pace.
                    </p>
                    <ul class="card-details">
                      <div className="mb-3">
                        <strong>Price:</strong>
                      </div>
                      <li className="d-flex">
                        <div>
                          <FontAwesomeIcon
                            icon={faCircleCheck}
                            className="card-icon"
                          />
                        </div>
                        <div>
                          US$ 10
                          <br />
                          <small>
                            (Equivalent To CBSL Middle Rate Of The Day)
                          </small>
                        </div>
                      </li>
                      <li className="d-flex">
                        <div>
                          <FontAwesomeIcon
                            icon={faCircleCheck}
                            className="card-icon"
                          />
                        </div>
                        <div> Tickets available at the gate.</div>
                      </li>
                    </ul>
                    <div className="card-button mt-5 ">
                      <button className="btn-bawa outline-btn">see more</button>
                    </div>
                  </div>
                </div>
              </div> */}

              <div className="d-flex px-3 justify-content-end align-items-end mt-5">
                <div style={{ height: "fit-content" }}>
                  <button className="btn-bawa primary-light-btn" onClick={() => window.location.href = '/packages'}>
                    see more
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container py-5">
          <div className="row mt-5">
            <div className="col-12 col-md-4">
              <p className="section-tag">
                [<span>Gallery</span>]
              </p>
            </div>
            <div className="col-12 col-md-8 ">
              <p className="section-header">
                Discover the timeless beauty of Brief Garden
              </p>
            </div>
            <div className="col-12 mt-md-5">
              <div className="parenth">
                <div className="divh1">
                  <img src={Home_gallery1} alt="Gallery" />
                </div>
                <div className="divh2">
                  <img src={Home_gallery2} alt="Gallery" />
                </div>
                <div className="divh3">
                  <img src={Hero} alt="Gallery" />
                </div>
                <div className="divh4">
                  <img src={Home_gallery4} alt="Gallery" />
                </div>
                <div className="divh5">
                  <img src={Home_gallery5} alt="Gallery" />
                </div>
                <div className="divh6">
                  <img src={Home_gallery3} alt="Galler2" />
                </div>
              </div>
              <div className="d-flex justify-content-end align-items-end mt-5">
                <div style={{ height: "fit-content" }}>
                  <button className="btn-bawa primary-dark-btn" onClick={() => window.location.href = '/gallery'}>
                    see more
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Home;
